import React from 'react';
import { SimpleForm, TextInput, Notification,
    Toolbar, SaveButton,
    useTranslate, useNotify,
    required, email } from 'react-admin';
import SendIcon from '@material-ui/icons/Send';

import { API_HOST } from '../env';
import { SectionTitle, Separator } from './ui_components';

const CustomToolbar = props => {
  const [requested, setRequested] = React.useState(false);
  const notify = useNotify();
  const handleRequest = (values) => {
    setRequested(true);
    const request = new Request(API_HOST + '/api/open/supervisors/password_reset_mail', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      credentials: 'omit',
      body: JSON.stringify({
        email: values.email
      }),
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          console.log("checkAuth error:" + response.statusText);
          console.log(response);
          const messageKey = 'ra.notification.item_doesnt_exist';
          notify(
            messageKey,
            'warning'
          );
          setRequested(false);
          return Promise.reject();
        }
        notify(
          'ra.notification.send',
        );
      });
  };

  return (
    <Toolbar {...props}>
      <SaveButton label='ra.action.send' icon={<SendIcon />} onSave={handleRequest} disabled={requested}/>
    </Toolbar>
  )
}

const PasswordResetMail = props => {
  const translate = useTranslate();

  const validates = [required(), email()];

  const validate = (values) => {
    const errors = {};
    if (values.email && values.email_confirm
        && values.email !== values.email_confirm) {
      errors.email_confirm = translate('resources.errors.email_mismatch');
    }
    return errors;
  };

  return (
    <div>
      <img alt='Life is Tech!' src='/images/header_logo_black.svg' width='15%' style={{margin: '2em 2em 0em 2em'}} />
      <SimpleForm validate={validate} toolbar={<CustomToolbar />}>
        <SectionTitle label="resources.labels.password_reset" />
        <Separator />
        <TextInput source="email" label={'ra.auth.email'} validate={validates}/>
        <TextInput source="email_confirm" label={'ra.auth.email_confirm'} validate={validates}/>
      </SimpleForm>
      <Notification />
    </div>
  );
}

export default PasswordResetMail;
